import i18n from '@omni/kit/localization';

const defaultGroupTypes = ['activity', 'community', 'small_group', 'team'];

export const getGroupTypeDisplayName = (name?: string): string => {
  if (!name) {
    return '';
  }

  return defaultGroupTypes.includes(name)
    ? (i18n.t(`groups:groupType_${name}`) as string)
    : name;
};
